import CreateEditTermsTemplateForm from './CreateEditTermsTemplateForm';

export default CreateEditTermsTemplateForm;
